import type { RendererProps } from "../core/element-registry"
import { Separator } from "../components/ui/separator"

export function SeparatorRenderer({ element }: RendererProps) {
  // Support both element.variant and element.direction for orientation
  const direction = element.direction ?? element.variant
  const orientation = direction === "vertical" ? "vertical" : "horizontal"

  // Apply height/width from styling for explicit sizing
  const styling = element.styling as Record<string, unknown> | undefined
  const inlineStyle: React.CSSProperties = {}
  if (styling?.height) inlineStyle.height = `${styling.height}px`
  if (styling?.width) inlineStyle.width = `${styling.width}px`
  const hasStyle = Object.keys(inlineStyle).length > 0

  return (
    <Separator
      orientation={orientation}
      className={element.className}
      style={hasStyle ? inlineStyle : undefined}
      data-testid={`separator-${element.id}`}
    />
  )
}
